import {FlowchartValidator} from '../platform/FlowchartValidator';
import {MaybeValidationError, ProcessFlowchartValidationError} from './ProcessFlowchartForValidationTypes';

export const pushErrors = (
  errors: Array<ProcessFlowchartValidationError>,
  errorOrErrors: MaybeValidationError | Array<ProcessFlowchartValidationError> | null,
  validator?: FlowchartValidator
): Array<ProcessFlowchartValidationError> => {
  let newErrors = [...errors];
  if (errorOrErrors != null) {
    if (Array.isArray(errorOrErrors)) {
      for (const error of errorOrErrors) {
        newErrors = pushErrors(newErrors, error, validator);
      }
    } else {
      newErrors = [
        ...newErrors,
        {
          ...errorOrErrors,
          errorMessage:
            validator?.errorTypeToMessageOverride[errorOrErrors.errorType] ?? errorOrErrors.errorMessage,
        },
      ];
    }
  }
  return newErrors;
};
